var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme, { easing } from 'Theme';
import { Button, Icon } from 'elements';
import { Tooltip } from 'reactstrap';
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: false,
            secure: _this.props.type === 'password',
            tooltip: false
        };
        _this.handleActive = function (active) { return function () { return _this.setState({ active: active }); }; };
        _this.handleKeyPress = function (event) {
            if (_this.props.onSubmit && event.nativeEvent.keyCode === 13)
                _this.props.onSubmit();
        };
        _this.toggleSecure = function () { return _this.setState({ secure: !_this.state.secure }); };
        _this.handleChange = function (event) {
            // console.log('Input- handleChange', event.target.value)
        };
        _this.handleToggleTooltip = function () {
            _this.setState(function (prev) { return ({ tooltip: !prev.tooltip }); });
        };
        return _this;
    }
    Input.prototype.render = function () {
        var _a = this.props, type = _a.type, name = _a.name, value = _a.value, label = _a.label, underline = _a.underline, min = _a.min, max = _a.max, maxLength = _a.maxLength, onSubmit = _a.onSubmit, disabled = _a.disabled, id = _a.id, tooltipContent = _a.tooltipContent, props = __rest(_a, ["type", "name", "value", "label", "underline", "min", "max", "maxLength", "onSubmit", "disabled", "id", "tooltipContent"]);
        var _b = this.state, active = _b.active, secure = _b.secure;
        // console.log('Input - value: ', value)
        var unfolded = active || String(value).length > 0;
        return (React.createElement(Wrapper, __assign({}, props),
            label ? (React.createElement(Label, { active: active, unfolded: unfolded }, label)) : null,
            React.createElement(StyledInput, { id: id, disabled: disabled, type: secure ? 'password' : 'text' || type, name: name, value: value, underline: underline, active: active, onChange: this.handleChange, onFocus: this.handleActive(true), onBlur: this.handleActive(false), min: min, max: max, maxLength: maxLength, onKeyPress: onSubmit ? this.handleKeyPress : undefined, secure: secure }),
            type === 'password' && (React.createElement(StyledButton, { onClick: this.toggleSecure },
                React.createElement(StyledIcon, { name: secure ? 'show' : 'hide' }))),
            id && React.createElement(Tooltip, { target: id, isOpen: this.state.tooltip, toggle: this.handleToggleTooltip }, tooltipContent)));
    };
    Input.defaultProps = {
        underline: true
    };
    return Input;
}(Component));
export default Input;
var Wrapper = cxs('label')({
    display: 'block',
    width: '100%',
    position: 'relative'
});
var Label = cxs('div')(function (_a) {
    var active = _a.active, unfolded = _a.unfolded;
    return ({
        height: Theme.fontSize.regular,
        fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
        color: active ? Theme.color.primary : Theme.color.placeholder,
        textAlign: 'left',
        transform: "translateY(".concat(unfolded ? 0 : '100%', ")"),
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    });
});
Label.propTypes = {
    active: PropTypes.bool,
    unfolded: PropTypes.bool
};
var StyledInput = cxs('input')(function (_a) {
    var underline = _a.underline, active = _a.active, secure = _a.secure;
    return (__assign({ width: '100%', height: '100%', transition: "border-color 450ms ".concat(easing.spring, " 0ms"), paddingRight: secure !== undefined ? Theme.size.space[3] : 0 }, underline
        ? {
            borderBottom: "".concat(Theme.size.hairline, " solid ").concat(active
                ? Theme.color.primary
                : Theme.color.hairline)
        }
        : undefined));
});
StyledInput.propTypes = {
    active: PropTypes.bool,
    underline: PropTypes.bool,
    secure: PropTypes.bool
};
var StyledButton = cxs(Button)({
    position: 'absolute',
    bottom: Theme.common.size.font * (Theme.common.size.lineHeight - 1) / 2 + 'px',
    right: 0
});
var StyledIcon = cxs(Icon)({
    color: Theme.color.placeholder
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/Input.tsx
// module id = 1018
// module chunks = 0